<template>
  <TheModal @close="closeModal" @save="submit">
    <ViewSelector
      v-if="['car', 'heavy_machinery'].includes(type)"
      :views="viewOptions"
      :value="inventoryView"
      @change="changeView"
    />

    <transition :name="transitionName" mode="out-in">
      <component
        :is="currentComponent"
        :inventory="inventory"
        :logs="logs"
        :type="type"
        :key="inventoryView"
      />
    </transition>

    <TheInput
      v-if="canBeParent && idToEdit"
      type="checkbox"
      :label="`Покажи в ${
        type === 'equipment' ? 'Тежка механизация' : 'Автомобили'
      }`"
      :disabled="toggling"
      v-model="showChildInventory"
      @change="showChildInventory = $event"
    />
  </TheModal>
</template>

<script>
import { mapGetters } from "vuex";
import log from "../mixins/log.js";
import TheInput from "@/components/TheInput.vue";
import TheModal from "@/components/shared/TheModal.vue";
import ViewSelector from "@/components/shared/ViewSelector.vue";
import InventoryBasic from "./InventoryBasic.vue";
import InventoryService from "./InventoryService.vue";
import InventoryMaintenance from "./InventoryMaintenance.vue";
import InventoryNotes from "./InventoryNotes.vue";
export default {
  mixins: [log],
  props: ["idToEdit", "type"],
  components: {
    TheInput,
    TheModal,
    ViewSelector,
    InventoryBasic,
    InventoryService,
    InventoryMaintenance,
    InventoryNotes,
  },
  computed: {
    ...mapGetters(["getUser"]),
    currentComponent() {
      return this.componentsNames[this.inventoryView];
    },
    canBeParent() {
      return ["equipment", "user_inventory"].includes(this.inventory.type);
    },
    childType() {
      return ["heavy_machinery", "car"].includes(this.inventory.type);
    },
  },
  data() {
    return {
      inventoryView: "basic",
      viewOptions: [
        { name: "ДАННИ ЗА АВТОМОБИЛА", icon: "O", value: "basic" },
        { name: "СРОКОВЕ ЗА ПЛАЩАНИЯ", icon: "P", value: "service" },
        { name: "РАЗХОДИ ЗА ПОДДРЪЖКА, €", icon: "R", value: "maintenanceLogs" },
        { name: "РЕГИСТЪР НА ИНВЕНТАРА", icon: "G", value: "noteLogs" },
      ],
      isNameValid: true,
      showChildInventory: false,
      toggling: false,
      logs: [],
      inventory: {
        name: "",
        brand: "",
        serialNumber: "",
        note: "",
        status: "",
      },
      previousView: null,
      transitionName: "slide-right",
      componentsNames: {
        basic: "InventoryBasic",
        service: "InventoryService",
        maintenanceLogs: "InventoryMaintenance",
        noteLogs: "InventoryNotes",
      },
    };
  },
  methods: {
    async toggleChildInventory(isVisible) {
      try {
        this.toggling = true;

        await this.$http.put(
          `${process.env.VUE_APP_BASE_URI}/inventory/toggleVisibility`,
          { inventory: this.inventory, isVisible }
        );

        this.toggling = false;
      } catch (err) {
        console.log(err);
      }
    },
    changeView(newView) {
      if (this.previousView) {
        const viewsOrder = ["basic", "service", "maintenanceLogs"];
        const currentIndex = viewsOrder.indexOf(this.inventoryView);
        const newIndex = viewsOrder.indexOf(newView);

        this.transitionName =
          newIndex > currentIndex ? "slide-right" : "slide-left";
      }
      this.previousView = this.inventoryView;
      this.inventoryView = newView;
    },
    getInventory(id) {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/inventory/${id}`)
        .then((response) => {
          this.inventory = response.data;
          this.getLogs();
          if (this.canBeParent && this.idToEdit) this.getChildVisibility();
        });
    },
    getLogs() {
      let url = `${process.env.VUE_APP_BASE_URI}/inventory/logs?l=1&inventory=${this.inventory._id}&getAll=true`;

      this.$http.get(url).then((response) => {
        this.logs = response.data;
      });
    },
    async getChildVisibility() {
      try {
        const childInventory = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/inventory/parent/${this.inventory._id}`
        );

        if (childInventory && childInventory.data) {
          this.showChildInventory = childInventory.data.visible;
        }
      } catch (err) {
        console.log(err);
      }
    },
    checkForm() {
      if (!this.childType && !this.inventory.name) this.isNameValid = false;
      if (this.childType) {
        let checkMainLogs = this.logs.some((l) => (!l.price || !l.activity) && !l.isEvent);

        if (checkMainLogs) {
          this.$snotify.warning("Всеки разход трябва да има стойност и вид");
          return false;
        }
      }

      // If everything is valid
      if (this.isNameValid) return true;
    },
    getInventoryName(i) {
      return [i.name, i.brand, i.serialNumber].filter((x) => x).join(" - ");
    },
    submit() {
      if (this.checkForm()) {
        this.$store.dispatch("startLoading");
        if (this.type) this.inventory.type = this.type;
        if (!this.inventory.status && !this.childType)
          this.inventory.location = null;

        const fd = new FormData();
        fd.append(
          "data",
          JSON.stringify({ ...this.inventory, logs: this.logs })
        );

        if (this.inventory.files && this.inventory.files.length) {
          for (let f of this.inventory.files) {
            fd.append("files", f);
          }
        }

        const method = this.idToEdit ? "put" : "post";
        this.$http[method](`${process.env.VUE_APP_BASE_URI}/inventory`, fd)
          .then(() => {
            if (this.idToEdit) {
              // create or edit child inventory
              if (this.canBeParent)
                this.toggleChildInventory(this.showChildInventory);
              this.$snotify.success("Успешно редактирахте инвентар!");
              this.newLog(
                "editInventory",
                this.getInventoryName(this.inventory)
              );
            } else {
              this.$snotify.success("Успешно регистрирахте нов инвентар!");
              this.newLog(
                "newInventory",
                this.getInventoryName(this.inventory)
              );
            }

            this.$store.dispatch("stopLoading");
            this.closeModal(true);
          })
          .catch((error) => {
            if (typeof error.response.data === "string") {
              this.$snotify.error(error.response.data);
            } else {
              console.log(error.response);
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            }
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$emit("close", { isEdited: isEdited });
    },
  },
  mounted() {
    if (this.idToEdit) this.getInventory(this.idToEdit);
  },
};
</script>
